import React, { useState } from 'react';
import MultiSelectStates from './MultiSelectStates';
import Icons from './Icons';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    states: [],
    email: '',
    phone: '',
    message: '',
    userType: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpiar error cuando el usuario empiece a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'El nombre completo es requerido';
    }

    if (formData.states.length === 0) {
      newErrors.states = 'Debes seleccionar al menos un estado';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'El correo electrónico es requerido';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'El correo electrónico no es válido';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'El mensaje es requerido';
    }

    if (!formData.userType) {
      newErrors.userType = 'Por favor selecciona una opción';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Aquí se integraría con el CRM (HubSpot, GoHighLevel, etc.)
      console.log('Datos del formulario:', formData);
      
      // Simular envío
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      alert('¡Mensaje enviado exitosamente! Nos pondremos en contacto contigo pronto.');
      
      // Limpiar formulario
      setFormData({
        fullName: '',
        states: [],
        email: '',
        phone: '',
        message: '',
        userType: ''
      });
      
    } catch (error) {
      alert('Hubo un error al enviar el mensaje. Por favor intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-section" id="contacto">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Contacto</h2>
          <p className="section-description">
            ¿Te gustaría formar parte de nuestro directorio de abogados o conocer más sobre los servicios que ofrece GesOps LLC?
          </p>
          <p className="section-description">
            Completa el formulario y uno de nuestros representantes se pondrá en contacto contigo para brindarte toda la información que necesites.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-form-container">
            <div className="form-header">
              <h3 className="form-title">Envíanos un mensaje</h3>
              <p className="form-subtitle">Completa el formulario y te contactaremos pronto</p>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fullName" className="form-label">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className={`form-input ${errors.fullName ? 'error' : ''}`}
                    placeholder="Tu nombre completo"
                  />
                  {errors.fullName && <span className="error-message">{errors.fullName}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="states" className="form-label">
                    Estados donde te encuentras o ejerces *
                  </label>
                  <MultiSelectStates
                    selectedStates={formData.states}
                    onChange={(states) => {
                      setFormData(prev => ({ ...prev, states }));
                      if (errors.states) {
                        setErrors(prev => ({ ...prev, states: '' }));
                      }
                    }}
                    error={errors.states}
                  />
                  {errors.states && <span className="error-message">{errors.states}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Correo Electrónico *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`form-input ${errors.email ? 'error' : ''}`}
                    placeholder="tu@email.com"
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="phone" className="form-label">
                    Teléfono (opcional)
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="+1 (555) 123-4567"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="userType" className="form-label">
                  Selecciona una opción *
                </label>
                <select
                  id="userType"
                  name="userType"
                  value={formData.userType}
                  onChange={handleInputChange}
                  className={`form-select ${errors.userType ? 'error' : ''}`}
                >
                  <option value="">Selecciona una opción</option>
                  <option value="inmigrante">Soy inmigrante</option>
                  <option value="abogado">Soy abogado</option>
                  <option value="otro">Otro</option>
                </select>
                {errors.userType && <span className="error-message">{errors.userType}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Mensaje *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className={`form-textarea ${errors.message ? 'error' : ''}`}
                  placeholder="Cuéntanos cómo podemos ayudarte..."
                  rows="5"
                ></textarea>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>

              <div className="form-submit">
                <button 
                  type="submit" 
                  className="btn btn-primary submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                </button>
              </div>
            </form>
            
            <div className="form-footer">
              <div className="response-time">
                <span className="response-icon"><Icons.Clock /></span>
                <div className="response-content">
                  <h4>Tiempo de respuesta</h4>
                  <p>Respondemos en menos de 24 horas</p>
                </div>
              </div>
              
              <div className="support-info">
                <span className="support-icon"><Icons.Users /></span>
                <div className="support-content">
                  <h4>Soporte personalizado</h4>
                  <p>Atención especializada para cada consulta</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <div className="info-card">
              <h3 className="info-title">Información de Contacto</h3>
              
              <div className="info-item">
                <span className="info-icon"><Icons.Building /></span>
                <div className="info-content">
                  <h4>GesOps LLC</h4>
                  <p>1420 Celebration Blvd STE 101<br />
                     Kissimmee, FL 34747, EE. UU.</p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon"><Icons.Email /></span>
                <div className="info-content">
                  <h4>Correo Electrónico</h4>
                  <p>info@gesops.com</p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon"><Icons.MessageSquare /></span>
                <div className="info-content">
                  <h4>WhatsApp Business</h4>
                  <p>Hacer clic para chatear</p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon"><Icons.Globe /></span>
                <div className="info-content">
                  <h4>Sitio Web</h4>
                  <p>www.gesops.com</p>
                </div>
              </div>
            </div>

            <div className="contact-disclaimer">
              <div className="disclaimer-box">
                <span className="disclaimer-icon"><Icons.Shield /></span>
                <div className="disclaimer-content">
                  <p>
                    <strong>Confidencialidad garantizada:</strong> La información proporcionada será tratada de forma confidencial y utilizada únicamente para fines de contacto profesional.
                  </p>
                </div>
              </div>
            </div>

            <div className="virtual-notice">
              <div className="notice-box">
                <span className="notice-icon"><Icons.AlertCircle /></span>
                <div className="notice-content">
                  <h4>Aviso Importante</h4>
                  <p>
                    GesOps LLC ofrece todos sus servicios de forma virtual. La dirección indicada corresponde únicamente a nuestra sede administrativa y de correspondencia en Kissimmee, Florida.
                  </p>
                  <p>
                    <strong>No se atiende público de manera presencial.</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-footer">
          <p className="contact-tagline">
            En GesOps creemos en las conexiones reales y en el crecimiento conjunto.
          </p>
          <p className="contact-subtitle">
            Si eres una compañía o un profesional: Escríbenos y descubre cómo podemos ayudarte a impulsar tu práctica,
            mejorar tu posicionamiento digital y fortalecer tu gestión operativa dentro de un entorno verificado y seguro.
            <br />
            <br />
            Si eres un usuario en busca de un profesional acreditado: Cuéntanos tu necesidad y te ayudaremos a conectar con
            uno de nuestros suscriptores verificados, brindándote una experiencia segura, confiable y libre de intermediarios
            no autorizados.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
